<div
  class="flex justify-content-between holidays-info align-items-center pl-2 pr-2"
  *ngIf="holidaysInfo()?.value && showInfo"
>
  <p class="text-center w-full">
    {{ holidaysInfo().value }}
  </p>
  <p-button icon="pi pi-times" [rounded]="true" (click)="closeInfo()" />
</div>
